let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("28paf")).then(() => parcelRequire('iBhA4'));